import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {HttpHeaders, HttpParams} from "@angular/common/http";
import {MatDialog} from '@angular/material/dialog';

import {HttpServiceService} from "../../services/httpService/http-service.service";
import {eventVersions, isViewMode, isViewModeByShareLink} from '../../../configs/view_only';
import {UserGuideService} from '@src/app/modules/user-guide/shared/user-guide.service';
import {SignUpModalComponent} from '@src/app/modules/user-guide/modals/sign-up-modal/sign-up-modal.component';
import { EventService } from '@src/app/core/services/event.service';

declare const Yiit;

@Component({
  selector: 'app-versions',
  templateUrl: './versions.component.html',
  styleUrls: ['./versions.component.scss']
})
export class VersionsComponent implements OnInit {
  public isDisabled: boolean;
  public versions = eventVersions;
  public currentVersion = null;
  public Yiit = Yiit;
  public isViewOnly = isViewMode || isViewModeByShareLink;

  constructor(
    private http: HttpServiceService,
    private cd: ChangeDetectorRef,
    private matDialog: MatDialog,
    private userGuideService: UserGuideService,
    private eventService: EventService,
  ) { }

  ngOnInit() {
    this.isDisabled = this.eventService.isLinkShare;

    this.versions.sort((a, b) => { return b.id - a.id; });
    this.versions.unshift({
      id: null,
      name: Yiit.t('Latest'),
      created_at: Date.now() / 1000,
    });
    const paths = window.location.pathname.split('/');

    if (paths.includes('link-share')) {
      this.currentVersion = this.versions[0];
      return;
    }

    const versionPath = paths[paths.length - 1];
    if (versionPath.substr(0, 1) === 'v') {
      const currentVersionId = parseInt(versionPath.substr(1));
      for (let i = 0; i < this.versions.length; i++) {
        if (this.versions[i].id == currentVersionId) {
          this.currentVersion = this.versions[i];
          break;
        }
      }
    } else {
      this.currentVersion = this.versions[0];
    }
  }

  getDate(timestamp) {
    const d = new Date();
    d.setTime(timestamp * 1000);
    return d.toLocaleDateString();
  }

  changeVersion() {
    if (this.currentVersion && this.currentVersion.id) {
        window.location.href = '/event/3d-map/' + window['EVENT_ID'] + '/v' + this.currentVersion.id + window.location.search;
    } else {
        window.location.href = '/event/3d-map/' + window['EVENT_ID'];
    }
  }

  addVersion() {
    // Just in case somebody un-disables button through DevTools
    if (this.isViewOnly) {return; }

    if (this.userGuideService.isFastSignup) {
      this.matDialog.open(SignUpModalComponent);
      return;
    }

    const name = window.prompt(Yiit.t("Version Name"));
    if (name && name.length > 0) {
      if (name.length > 30) {
        alert(Yiit.t('Version Name should be no longer than 30 symbols.'));
        return;
      }
      this.http.sendPostRequest(
        '/version/create/' + window['EVENT_ID'],
        new HttpParams()
          .set('name', name)
          .toString(),
        new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      ).subscribe((result)=>{
        try {
          const obj = JSON.parse(result);
          if (obj.success) {
            this.versions.splice(1, 0, obj['version']);
          } else {
            alert(Object.values(obj['errors'])['flat'](99).join("\n"));
          }
          this.cd.detectChanges();
        } catch (e) {
          alert(Yiit.t("Technical error. Please, try again later."));
          console.error(e);
        }
      }, (err)=>{
        alert(Yiit.t("Technical error. Please, try again later."));
        console.error(err);
      })
    }
  }

}
